<template>
  <div>
    <ContentBlocks :entry="entry" :social-media-accounts="socialMediaAccounts" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const MarketingPageFragment = gql`
  fragment MarketingPageFragment on marketing_Entry {
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
    seoTopics
  }
  ${ContentBlocksMatrixFragment}
`;

export const HomePageFragment = gql`
  fragment HomePageFragment on home_Entry {
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
    seoTopics
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'MarketingPage',
  components: {
    ContentBlocks,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
    socialMediaAccounts: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
